import { memo } from 'react';

import { usePersistentStorageManagement } from './hooks/usePersistentStorageManagement';
import { PersistentStorageContextProps } from './types/PersistentStorageContextProps';
import { PersistentStorageApiContext } from './PersistentStorageApiContext';

const PersistentStorageProviderComponent = ({
  children,
  namespace,
  allowedKeys,
}: PersistentStorageContextProps) => {
  const { apiValue } = usePersistentStorageManagement(namespace, allowedKeys);

  return (
    <PersistentStorageApiContext.Provider value={apiValue}>
      {children}
    </PersistentStorageApiContext.Provider>
  );
};

export const PersistentStorageProvider = memo(
  PersistentStorageProviderComponent,
);
